/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { typeMemberSchema } from "./typeMemberSchema.ts";
import { z } from "zod";

/**
 * @description Représentation d\'un membre invité mais pas encore inscrit
 */
export const accountMemberOtherSchema = z.object({
      "email": z.string().email().optional(),
  "type": z.lazy(() => typeMemberSchema).describe("Type de membre dans l'organisation").optional()
      }).describe("Représentation d'un membre invité mais pas encore inscrit")